import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import {
  HouseWifi,
  LogIn,
  MonitorIcon,
  TvMinimalPlay,
  Video
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Home() {

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-r from-green-600 to-green-800 text-white">
        <div className="container mx-auto px-4 py-20 md:py-32">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Hệ thống Quản lý Cuộc họp Thông minh
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-green-100">
              Tổ chức và quản lý cuộc họp trực tuyến một cách chuyên nghiệp và
              hiệu quả
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                onClick={() => navigate("/login")}
                className="bg-white text-green-600 hover:bg-green-50 text-lg px-8 py-6"
              >
                <LogIn className="mr-2 h-5 w-5" />
                Đăng nhập
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => navigate("/register")}
                className="bg-transparent border-2 border-white text-white hover:bg-white/10 text-lg px-8 py-6"
              >
                Đăng ký
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Tính năng nổi bật
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Công cụ toàn diện để quản lý cuộc họp và phòng họp của bạn
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="border-2 hover:border-green-500 transition-colors">
              <CardHeader>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <TvMinimalPlay className="h-6 w-6 text-green-600" />
                </div>
                <CardTitle>Quản lý Cuộc họp</CardTitle>
                <CardDescription>
                  Tạo, lên lịch và quản lý cuộc họp trực tuyến dễ dàng
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-2 hover:border-green-500 transition-colors">
              <CardHeader>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <HouseWifi className="h-6 w-6 text-green-600" />
                </div>
                <CardTitle>Phòng họp</CardTitle>
                <CardDescription>
                  Quản lý và đặt phòng họp với đầy đủ thiết bị hỗ trợ
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-2 hover:border-green-500 transition-colors">
              <CardHeader>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <MonitorIcon className="h-6 w-6 text-green-600" />
                </div>
                <CardTitle>Thiết bị</CardTitle>
                <CardDescription>
                  Theo dõi và quản lý thiết bị họp trực tuyến
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-2 hover:border-green-500 transition-colors">
              <CardHeader>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <Video className="h-6 w-6 text-green-600" />
                </div>
                <CardTitle>Video Conference</CardTitle>
                <CardDescription>
                  Tham gia cuộc họp với chất lượng video HD
                </CardDescription>
              </CardHeader>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-green-600 to-green-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Sẵn sàng bắt đầu?
          </h2>
          <p className="text-xl mb-8 text-green-100">
            Đăng ký ngay để trải nghiệm các tính năng tuyệt vời
          </p>
          <Button
            size="lg"
            onClick={() => navigate("/register")}
            className="bg-white text-green-600 hover:bg-green-50 text-lg px-8 py-6"
          >
            Đăng ký miễn phí
          </Button>
        </div>
      </section>
    </div>
  );
}
